import "./welcome.css"
import React from "react";
import {useTranslation} from "react-i18next";
import Logout from "../../logout/Logout";
import {connect} from "react-redux";
import "react-html5-camera-photo/build/css/index.css";
import UploadButton from "./UploadButtons";

function WelcomeToInfo({appData}) {
    const {t} = useTranslation()

    return (
        <div className="welcome_to w-full h-auto">
            <Logout/>
            <p className="welcome_to_heading text-white text-center font-normal xl:text-7xl text-5xl">{t('welcome_to.welcome_to')}</p>
            <div className="welcome_to_content m-auto">
                <p className="app_complete_text text-white font-medium text-xl">
                    {t('welcome_to.complete_app')} {appData.app_id} {t('welcome_to.complete_app_number')}
                </p>
                <p className="app_complete_text text-white font-medium text-xl">{t('welcome_to.complete_app_continue')}</p>
                <h1 className="verification_heading text-white text-center font-semibold sm:text-6xl text-5xl">{t("welcome_to.doc_verification")}</h1>
                <div>
                    <p className="account_funding_text text-white font-medium text-xl">{t('welcome_to.complete_app_continue1')}</p>
                </div>
                <p className="attention_text text-white font-semibold text-xl pt-3">
                    {t('welcome_to.complete_app_continue2')}
                    <a href="mailto: service@choicetrade.com"
                       className="text-white"> {t('welcome_to.mail_to')} </a>
                    {t('welcome_to.complete_app_continue3')}
                </p>
            </div>

            <UploadButton/>
        </div>
    )
}

const mapStateToProps = (state) => ({
    appData: state.appData
});

export default connect(mapStateToProps)(WelcomeToInfo);